export enum FooterCopyMode {
    Undefined = 0,
    LooseCopy = 1,
    ManagedCopy = 2
}
